export default "__VITE_ASSET__Ftk6Tdcu__"